<div class="container-fluid px-0">
    <div class="row pb-2">
        <div class="col-12 d-flex justify-content-end">
            @if (showReorderButtons) {
                <button class="btn btn-outline-info btn-sm ms-2"
                        (click)="reorderTrait('down')"
                        [ngbTooltip]="'study-editor.variable.table.move.down' | translate"
                        [disabled]="isVariableMoving || getSelectedItems().length !== 1 || findIndex(getSelectedItems()[0]) === filteredVariables?.length - 1">
                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                </button>
                <button class="btn btn-outline-info btn-sm ms-2"
                        (click)="reorderTrait('up')"
                        [ngbTooltip]="'study-editor.variable.table.move.up' | translate"
                        [disabled]="isVariableMoving || getSelectedItems().length !== 1 || findIndex(getSelectedItems()[0]) === 0">
                    <i class="fa fa-chevron-up" aria-hidden="true"></i>
                </button>
            }

            @if (getSelectableItems().length > 0 && showEditAliasButton) {
                <button class="btn btn-outline-info btn-sm ms-2"
                        (click)="onEditAlias()"
                        [ngbTooltip]="'study-editor.variable.table.edit.alias' | translate"
                        [disabled]="!getSelectedItems().length || getSelectedItems().length !== 1">
                    <i class="fa fa-edit" aria-hidden="true"></i>
                </button>
            }

            @if (getSelectableItems().length > 0 && showDeleteButton) {
                <button class="btn btn-outline-info btn-sm ms-2"
                        (click)="onRemoveVariables()"
                        [ngbTooltip]="'study-editor.variable.table.remove' | translate"
                        [disabled]="!getSelectedItems().length">
                    <i class="fa fa-trash" aria-hidden="true"></i>
                </button>
            }

            @if (showAddButton) {
                <button class="btn btn-outline-info btn-sm ms-2"
                        (click)="onAddVariableClick()"
                        [ngbTooltip]="'common.add' | translate">
                    <i class="fa fa-plus" aria-hidden="true"></i>
                </button>
            }
        </div>
    </div>
    <div class="container-fluid px-0">
        <div class="custom-scroll-style" style="max-height: 350px; overflow-y: auto; overflow-x: auto;">
            <table class="table table-striped table-bordered table-curved mb-0">
                <thead class="sticky-header">
                <tr>
                    <th class="text-center" style="border-top: 0; width: 30px;">
                        @if (showDeleteButton) {
                            <input type="checkbox" class="form-check-input m-2"
                                   [(ngModel)]="isSelectAll"
                                   (change)="doSelectAll()">
                        }
                    </th>
                    <th style="width: 150px; border-top: 0;" jhiTranslate="study-editor.variable.table.header.name">
                        Name
                    </th>
                    <th style="width: auto; border-top: 0;"
                        jhiTranslate="study-editor.variable.table.header.description">Description
                    </th>
                    @if (showInputVariablesColumn) {
                        <th style="width: auto; border-top: 0;"
                            jhiTranslate="study-editor.variable.table.header.input.variables">Input Variables
                        </th>
                    }
                </tr>
                </thead>
                <tbody>
                    @for (variable of filteredVariables; track variable.termId; let row = $index;) {
                        <tr (click)="toggleSelect($event, row, variable); $event.stopPropagation()"
                            (mousedown)="preventDefaultOnShiftKey($event)"
                            [class.selected]="isSelected(variable.termId)">
                            <td>
                                @if (variable.deletable && showDeleteButton) {
                                    <input type="checkbox" class="form-check-input m-1"
                                           [checked]="isSelected(variable.termId)"
                                           (change)="toggleSelect($event, row, variable, true)"
                                           (click)="$event.stopPropagation()">
                                }
                            </td>
                            <td style="width: 150px;">
                                @if (variable.alias && variable.alias !== variable.name) {
                                    <a class="" [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
                                       [queryParams]="{ variableId: variable.termId }" [ngbTooltip]="variable.name" [openDelay]="800"
                                       queryParamsHandling="merge"><truncate-span [textInput]="variable.alias"></truncate-span></a>
                                } @else {
                                    <a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
                                       [queryParams]="{ variableId: variable.termId }"
                                       queryParamsHandling="merge"><truncate-span [textInput]="variable.name"></truncate-span></a>
                                }

                            </td>
                            <td class="text-wrap"><truncate-span [textInput]="variable.description" [maxLength]="100"></truncate-span></td>
                            @if (showInputVariablesColumn) {
                                <td>
                                    @if (variable.formula?.inputs?.length) {
                                        @for (input of variable?.formula?.inputs; track input?.id) {
                                            <span>
                                            <a [routerLink]="['/', { outlets: { popup: 'variable-details-popup' }}]"
                                               [queryParams]="{ variableId: input.id }"
                                               queryParamsHandling="merge">{{ input?.name }}</a>
                                            <span *ngIf="!$last">, </span>
                                        </span>
                                        }
                                    }
                                </td>
                            }
                        </tr>
                    } @empty {
                        <tr>
                            <td colspan="4" class="text-center text-muted">
                                <span jhiTranslate="study-editor.variable.table.empty">No variables found.</span>
                            </td>
                        </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>
</div>
